import { Const } from '../lib/const.cls'

export const mutations = {
	//Contact us
	[Const.SET_CONTACT_US] (state, data) {							
		try {state.contact_us = data} catch (ex) {console.debug('set state EX', ex)}
		
	},
	[Const.SET_COUNTRIES_LIST] (state, data) {									
		try {state.countriesList = data} catch (ex) {console.debug('set state EX', ex)}
	},
	[Const.SET_CITIES_LIST] (state, data) {									
		try {state.citiesList = data} catch (ex) {console.debug('set state EX', ex)}
	},
	//email
	[Const.SET_EMAIL_SETTING_LIST] (state, data) {									
		try {
			state.emailList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//coupon
	[Const.SET_COUPON_LIST] (state, data) {									
		try {
			state.couponList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_SUB_EXSIST_LIST] (state, data) {									
		try {
			state.subExistList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_SUB_PLAN_LIST] (state, data) {									
		try {
			state.sunPlanList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_SUB_PLAN_DETAIL] (state, data) {									
		try {
			state.subPlanDetail = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//reporting
	[Const.SET_REPORTING_LIST] (state, data) {									
		try {
			state.reportingList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_EMIR_LIST] (state, data) {									
		try {
			state.emirList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//admin
	[Const.SET_ADMIN_LIST] (state, data) {									
		try {
			state.adminList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_LOGS_LIST] (state, data) {									
		try {
			state.logsList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_LOGS_VIEW] (state, data) {									
		try {
			state.logsView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_ADMIN_DETAIL] (state, data) {									
		try {
			state.adminDetail = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	//client
	[Const.SET_WITHDRAWAL_METHODS] (state, data) {									
		try {
			state.withdrawalMethods = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WITHDRAWAL_METHOD_RESPONSE] (state, data) {									
		try {
			state.withdrawalMethodResponse = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_ARTICLE_LIST] (state, data) {									
		try {
			state.articleList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_CAT_LIST] (state, data) {									
		try {
			state.catList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_SUBIB_LIST] (state, data) {									
		try {
			state.ibList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_USER_LIST] (state, data) {									
		try {
			state.userList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_MASTER_LIST] (state,data){
		try {
			state.masterList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_USER_VIEW] (state, data) {									
		try {
			state.userView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_USER_COUNT] (state, data) {									
		try {
			state.userCount = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_INTERNAL_NOTES] (state, data) {									
		try {
			state.internalNotes = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_RISK_METRIX] (state, data) {									
		try {
			state.riskMetrix = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	//deposit
	[Const.SET_DEPOSIT_LIST]: (state, data) => {		
		try {
			state.depositList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_DEPOSIT_TRANSACTION]: (state, data) => {		
		try {
			state.depositTransaction = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_DEPOSIT_VIEW]: (state, data) => {		
		try {
			state.depositView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	//commission
	[Const.SET_COMMISSION_LIST]: (state, data) => {		
		try {
			state.commissionList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_COMMISSION_VIEW]: (state, data) => {		
		try {
			state.commissionView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	//bonus
	[Const.SET_BONUS_LIST]: (state, data) => {		
		try {
			state.bonusList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_BONUS_VIEW]: (state, data) => {		
		try {
			state.bonusView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	//ticket
	[Const.SET_TICKET_LIST]: (state, data) => {		
		try {
			state.ticketList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TICKET_REASON_LIST]: (state, data) => {		
		try {
			state.ticketReasonList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TICKET_VIEW]: (state, data) => {		
		try {
			state.ticketView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TICKET_DOCS]: (state, data) => {		
		try {
			state.ticketDocs = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	//withdrawal
	[Const.SET_WITHDRAWAL_LIST]: (state, data) => {	
		try {
			state.withdrawalList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_WITHDRAWAL_VIEW]: (state, data) => {	
		try {
			state.withdrawalView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	
	//trading
	[Const.SET_TRADING_LIST]: (state, data) => {	
		try {
			state.tradingList = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},
	[Const.SET_TRADING_VIEW]: (state, data) => {	
		try {
			state.tradingView = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	[Const.SET_NOTIFICATION_LISTING]: (state, data) => {
		try {
			state.notifications = data
		} catch (ex) {
			console.debug('set state EX', ex)
		}
	},

	// bonus booster campaigns
	[Const.SET_BB_CAMPAIGN_LIST]: (state, data) => {
		try { state.bbCampaignList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_BB_CAMPAIGN_DETAIL]: (state, data) => {
		try { state.bbCampaignDetail = data } catch (ex) { console.debug('set state EX', ex) }
	},

	// bonus booster codes
	[Const.SET_BB_CODE_LIST]: (state, data) => {
		try { state.bbCodeList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_BB_CODE_DETAIL]: (state, data) => {
		try { state.bbCodeDetail = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_BB_REDEMPTION_LIST]: (state, data) => {
		try { state.bbRedemptionList = data } catch (ex) { console.debug('set state EX', ex) }
	},
	[Const.SET_BB_REDEMPTION_DETAIL]: (state, data) => {
		try { state.bbRedemptionDetail = data } catch (ex) { console.debug('set state EX', ex) }
	},
}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/mutations.js